import { render, staticRenderFns } from "./AddSample.vue?vue&type=template&id=54ce413f"
import script from "./AddSample.vue?vue&type=script&lang=js"
export * from "./AddSample.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports